import moment from "moment";
import { getCurrentUser } from "../../../store/selectors/Accounts";
import {HttpCase} from  "../../../utils/Http";
export const IpAddress = "https://visacare.com"
export const IpAddress3 = "https://52.70.64.207"
export const IpAddress2 = "https://legal.visacare.com"
export const IpAddress1 = "https://34.200.25.17"
export const defaultLawfirmEmailId = "raj@immlaws.com"
export const permApplicationCaseName = "PERM Application"
export const USDATEFORMAT = "MM-dd-yyyy"
export const USCALDATEFORMAT = "mm/dd/yy"
export const USCALDATEFORMATMMDDYYYY = "mm/dd/yyyy"
export const VISABUILDINDATEFORMAT = "MM-yy"
export const DYIPLANID = 1
export const ATORNEYHELPPLANID = 2
export const SUPERADMINROLEID = 18616
export const EMPLOYERADMINROLEID = 3
export const EMPLOYEEROLEID = 5
export const LAWFIRMADMINROLEID = 8
export const ATTORNEYROLEID = 9
export const ATTORNEYASSISTANTUSERROLEID = 13
export const VISACAREADMINASSISTANTROLEID = 14
export const defaultLawfirmId = 1;
export const defaultAttorneyId = 4;
export const defaultPassword = "Admin@1234";
export const regexEmail = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const regexEmailSeparatedByComma = /^([A-Za-z]+[A-Za-z0-9.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}(\s*(;|,)\s*|\s*$))+$/i;

export const EMPLOYEEROLENAME = "EMPLOYEE"
export const employeeRoleName = "Employee"
export const employerAdminRoleName = "EmployerAdmin"
export const employerAssistantRoleName = "EmployerAssistant"
export const PROVIDERADMINROLENAME = "ProviderAdmin"
export const VISACAREADMINROLENAME = "VisaCareAdmin"
export const VISACAREADMINASSISTANTROLENAME = "VisaCareAdminAssistant"
export const ATTORNEYROLENAME = "Attorney"
export const ATTORNEYASSISTANTUSERROLENAME = "Attorney Assistant"
export const LAWFIRMADMIN = "LawFirmAdmin"
export const PROVIDERSUPPORTROLENAME = "ProviderSupport"
export const UICHECKROLENAME = "UICHECK"
export const variableListFileUoloadId = 10;
export const curentUser = getCurrentUser();
export const specialCharactor = /[$!&=-]/;
export const zipCodeFormat = /^([0-9](4,6))+$/;
export const numbersOnly = /^[0-9\b]+$/;
export const usPhoneNumberFormat = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const emailIdFormatOld = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i;
export const emailIdFormat = /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,})+$/i;
export const PLANNAMEDYI = "DIY"
export const PLANNAMELEGAL = "LEGAL"
export const matchUPS1 = /\b(1Z ?[0-9A-Z]{3} ?[0-9A-Z]{3} ?[0-9A-Z]{2} ?[0-9A-Z]{4} ?[0-9A-Z]{3} ?[0-9A-Z]|[\dT]\d\d\d ?\d\d\d\d ?\d\d\d)\b/;
export const matchUPS2 = /^[kKJj]{1}[0-9]{10}$/;
export const ApiKey = `7MKmOXLDS6JuzQhhJwV7VQ7JdYh5IENaRAJ5qscf`;
export const matchUSPS0 = /(\b\d{30}\b)|(\b91\d+\b)|(\b\d{20}\b)/;
export const matchUSPS1 = /(\b\d{30}\b)|(\b91\d+\b)|(\b\d{20}\b)|(\b\d{26}\b)| ^E\D{1}\d{9}\D{2}$|^9\d{15,21}$| ^91[0-9]+$| ^[A-Za-z]{2}[0-9]+US$/i;
export const matchUSPS2 = /^E\D{1}\d{9}\D{2}$|^9\d{15,21}$/;
export const matchUSPS3 = /^91[0-9]+$/;
export const matchUSPS4 = /^[A-Za-z]{2}[0-9]+US$/;
export const matchUSPS5 = /(\b\d{30}\b)|(\b91\d+\b)|(\b\d{20}\b)|(\b\d{26}\b)| ^E\D{1}\d{9}\D{2}$|^9\d{15,21}$| ^91[0-9]+$| ^[A-Za-z]{2}[0-9]+US$/i;

export const matchFedex1 = /(\b96\d{20}\b)|(\b\d{15}\b)|(\b\d{12}\b)/;
export const matchFedex2 = /\b((98\d\d\d\d\d?\d\d\d\d|98\d\d) ?\d\d\d\d ?\d\d\d\d( ?\d\d\d)?)\b/;
export const matchFedex3 = /^[0-9]{15}$/;
export const feinPattern = /^[1-9][0-9]{7}$/;
export const todaydateTime = new Date();
export const currentYear = new Date().getFullYear();
export const caseNameJson = [
  { id: 21, casename: "H1B Public Access File Only", urlName: "visaCarePAFCaseDetails" },
  { id: 22, casename: "I-129 - H1B Petition", urlName: "visaCareH1BCaseDetails" },
  { id: 23, casename: "I-539 - H4 Application", urlName: "visaCareH4CaseDetails" },
  { id: 24, casename: "I-140 Application", urlName: "visaCareI140CaseDetails" },
  { id: 25, casename: "H1B LCA Only", urlName: "visaCareFLCCaseDetails" },
  { id: 26, casename: "I-765 - EAD Application", urlName: "visaCareI765CaseDetails" },
  { id: 27, casename: "PERM Application", urlName: "visaCarePermCaseDetails" }, 
  { id: 31, casename: "I-131 Advanced Parole", urlName: "visaCareI131CaseDetails" },
  { id: 30, casename: "I-130 Application", urlName: "visaCareI130CaseDetails" },
  { id: 32, casename: "I-864 Application", urlName: "visaCareI864CaseDetails" },
  { id: 33, casename: "I-485 Application", urlName: "visaCareI485CaseDetails" },
  { id: 34, casename: "I-765 - EAD Dependants", urlName: "visaCareI765CaseDetails" },
  { id: 35, casename: "I-485 Dependant", urlName: "visaCareI485CaseDetails" },
  { id: 36, casename: "I-131 Advanced Parole - Dependant", urlName: "visaCareI131CaseDetails" },
  { id: 37, casename: "I-130A Application", urlName: "visaCareI130ACaseDetails" }
]

export const serverRunningService = [
  {id: 1, applicationName: "VISACARE-CONFIG-SERVER",port:"9296", status: "Running", description:"System related config details"},
  {id: 2, applicationName: "VISACARE-EMPLOYEE-DETAILS-SERVICE",port:"8085", status: "Running", description:"The services include Employee details, I-130 Application details, I-131 Advance Parole details, I-485 Application details, I-864 Application details, PERM Application details, Document Types and WOPI Documents"},
  {id: 3, applicationName: "VISACARE-H1BFORMS-SERVICE",port:"8084", status: "Running", description:"The services include I-129 - H1B Petition Forms, I-130 Application Forms and I-140 Application Forms"},
  {id: 4, applicationName: "VISACARE-H4FORMS-SERVICE",port:"8089", status: "Running", description:"The services include I-539 - H4 Application Details and I-539 - H4 Application Forms"},
  {id: 5, applicationName: "VISACARE-FORMTYPES-SERVICE",port:"8088", status: "Running", description:"The services include Company profile details, Company extension details, Form type details and LCA code details"},
  {id: 6, applicationName: "VISACARE-API-GATEWAY",port:"9191", status: "Running", description:"The services include User details, User profile details, Company additional details, Common details, Role details, Permission details, Role Permission details, Docu sign Details and Fedex details etc.,"},
  {id: 7, applicationName: "VISACARE-UPCOMINGEVENTS",port:"8094", status: "Running", description:"The services include Upcoming event details"},
  {id: 8, applicationName: "VISACARE-TRACKING-SERVICE",port:"8093", status: "Running", description:"The services include USCIS tracking details"},
  {id: 9, applicationName: "VISACARE-PAYMENT-SERVICE",port:"8091", status: "Running", description:"The services include Payment details"},
  {id: 10, applicationName: "VISACARE-EMAIL-SERVICE",port:"8090", status: "Running", description:"The services include Mail services"},
  {id: 11, applicationName: "VISACARE-WORKFLOW-SERVICE",port:"8082", status: "Running", description:"The services include Work flow services"},
  {id: 12, applicationName: "VISACARE-FILE-UPLOAD",port:"8087", status: "Running", description:"The services include File upload details"},
  {id: 13, applicationName: "VISACARE-COMMONMAINTENANCE",port:"8096", status: "Running", description:"The services include Visacare templates and Other Common maintenance details"},
  {id: 14, applicationName: "VISACARE-REPORTING",port:"8097", status: "Running", description:"The services include Report realted details"},
  {id: 15, applicationName: "VISACARE-CASEFLOW-DETAILS-SERVICE",port:"8086", status: "Running", description:"The services include Caseflow lca form details, Education details, G-28 details, Attorney details and Pdf generated details"},
  {id: 16, applicationName: "VISACARE-EADAPPLICATION",port:"8095", status: "Running", description:"The services include I-765 - EAD Application details and I-765 - EAD Application forms"},
  {id: 17, applicationName: "VISACARE-CASEFLOW-SERVICE",port:"8083", status: "Running", description:"The services include Case related details, Preparer details, I9 details, Order details and Other report details"}
]

export const h1bMenuItems = [
        { id: 1, label: 'Initiation', value: 'Initiation' },
        { id: 2, label: 'LCA/PAF', value: 'LCA/PAF' },
        { id: 3, label: 'Education', value: 'Education' },
        { id: 4, label: 'Case Questionnaire', value: 'Case Questionnaire' },
        { id: 5, label: 'Upload Documents', value: 'Upload Documents' },
        { id: 6, label: 'Forms', value: 'Forms' },
        { id: 7, label: 'Case Submission', value: 'Case Submission' },
        { id: 8, label: 'USCIS Receipt', value: 'USCIS Receipt' },
        { id: 9, label: 'RFE', value: 'RFE' },
        { id: 10, label: 'Decision', value: 'Decision' },
        { id: 11, label: 'Visa Package', value: 'Visa Package' },
        { id: 12, label: 'Termination', value: 'Termination' },
        { id: 13, label: 'Case Notes', value: 'Case Notes' }
    ];

export const planNameJson = [
  { id: 1, planName: "Do It Yourself" },
  { id: 2, planName: "With ATTORNEY legal representation" }
]
export const workFlowJson = [
  { id: 1, workFlowName: "Case Initiated" },
  { id: 5, workFlowName: "LCA Inprogress" },
  { id: 10, workFlowName: "LCA Completed" },
  { id: 15, workFlowName: "Form Generated" },
  { id: 20, workFlowName: "Form Prepared" },
  { id: 25, workFlowName: "Case Submitted" },
  { id: 30, workFlowName: "USCIS Receipt Completed" },
  { id: 35, workFlowName: "RFE Completed" },
  { id: 50, workFlowName: "Case Completed" }
]
export const addressType = [
  { id: 1, addressType: "PAD", addressTypeName: "" },
  { id: 2, addressType: "BAD", addressTypeName: "" },
  { id: 3, addressType: "BFA", addressTypeName: "" },
  { id: 4, addressType: "EEA", addressTypeName: "" },
  { id: 5, addressType: "PPA", addressTypeName: "" },
  { id: 6, addressType: "H1B1A", addressTypeName: "" }
]

export const relationship = [
  { label: 'Father', value: 'Father' },
  { label: 'Mother', value: 'Mother' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Son', value: 'Son' },
  { label: 'Daughter', value: 'Daughter' }  
]

export const eligibilityCategory = [
  { label: '(c)(3)(A) EAD For Student Pre-Completion', value: '(C)(3)(A)' },
  { label: '(c)(3)(B) EAD For Student Post-Completion', value: '(C)(3)(B)' },
  { label: '(c)(3)(C) EAD For STEM Extension', value: '(C)(3)(C)' },
  { label: '(c)(9) EAD For AOS', value: '(C)(9)' },
  { label: '(c)(26)  H4 EAD', value: '(C)(26)' }   
]

export const formatFirstName = (value: any) => {
  if (value !== null && value !== "" && value !== undefined) {
    const arr = value.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();

    }
    const firstName = arr.join(" ");
    return firstName;
  } else {
    return value;
  }
}

// Country dropdowns store "United States of America" in mixed or upper case
export const isUSCountry = (value: any) => {
  return value !== null && value !== undefined && String(value).trim().toUpperCase() === "UNITED STATES OF AMERICA";
}

// State selects: pages save either the short name ("NY") or the full name
// ("New York" / "NEW YORK"). Returns the value of the option matching the
// saved state either way (optionKey = the field the select's options use as
// value), so the select shows it; anything else is returned unchanged.
export const stateOptionValue = (value: any, states: any[], optionKey: "stateshortname" | "statename") => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const saved = String(value).trim().toUpperCase();
  const match = (states || []).find((item) =>
    String(item.stateshortname || "").trim().toUpperCase() === saved ||
    String(item.statename || "").trim().toUpperCase() === saved);
  return match ? match[optionKey] : value;
}

export const formatRemoveSpecialChar = (value: any) => {

  value = value.replace(/[^a-zA-Z0-9]/g, ' ');
  return value;
}
export const formatRemoveSpecialCharToEmpty = (value: any) => {

  value = value.replace(/[^a-zA-Z0-9]/g, '');
  return value;
}

export const formatUploadFileName = (filePath: string): string => {
  const lastDotIndex = filePath.lastIndexOf('.');
  let sanitizedName: string;
  if (lastDotIndex !== -1) {
    const namePart = filePath.slice(0, lastDotIndex);
    sanitizedName = namePart.replace(/[^a-zA-Z0-9-_]/g, '');
  } else {
    sanitizedName = filePath.replace(/[^a-zA-Z0-9-_]/g, '');
  }
  // return sanitizedName.slice(0, 25);
  return sanitizedName;
};
export const formatUploadFormType = (value: any) => {
  var displayUploadFormType = value;
  switch (value) {
    case "SUPPORT_LETTER_ALONE":
      displayUploadFormType = "Support Letter";
      break;
    case "SUPPORT_LETTER_ANSWER_PART_4":
      displayUploadFormType = "Answer Part-4";
      break;
    case "SUPPORT_LETTER_ITINERARY":
      displayUploadFormType = "Itinerary";
      break;
    case "SUPPORT_LETTER_JOBDUTITES":
      displayUploadFormType = "Job Dutites";
      break;

  }
  return displayUploadFormType;

}

export const formatI94Number = (value: any) => {
  if (!value) return value;
  var newvalue = value.split(' ').join('');
  return newvalue.split('').join(' ');
}
export const formatPhoneNumber = (value: string | number): string => {
  if (!value) return "";
  value = String(value);

  if (value.charAt(0) === "1" || value.charAt(0) === "0") {
    value = value.slice(1);
  }

  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

export const formatUSPhoneNumberWithoutCountryCode = (value: any) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;


  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
export const formatFEINNumber = (value: any) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const feinNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const feinNumberLength = feinNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (feinNumberLength < 3) return feinNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  /* if (feinNumberLength < 7) {
     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
   }*/

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `${feinNumber.slice(0, 2)}-${feinNumber.slice(2, 9)}`;
}
export const arrayOneToThirty = [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 },
{ id: 11 }, { id: 12 }, { id: 13 }, { id: 14 }, { id: 15 }, { id: 16 }, { id: 17 }, { id: 18 }, { id: 19 }, { id: 20 },
{ id: 21 }, { id: 22 }, { id: 23 }, { id: 24 }, { id: 25 }, { id: 26 }, { id: 27 }, { id: 28 }, { id: 29 }, { id: 30 }
]
export const serviceCenter = [
  { name: "-Select-", address: "" },
  { name: "Vermont Service Center (Non Premium)", address: "USCIS Vermont Service Center Attn: I-129 H-1B, 38 River Road Essex Junction, VT 05452" },
  { name: "Vermont Service Center (Premium - CAP and Non CAP)", address: "USCIS Vermont Service Center Attn: I-129 H-1B,30 River Road Essex Junction, VT 05452-3808" },
  { name: "Vermont Service Center (MASTER CAP SUBJECT)", address: "USCIS Vermont Service Center Attn: I-129 H-1B Master’s Cap, 38 River Road Suite 1000 Essex Junction, VT 05452" },
  { name: "Vermont Service Center (REGULAR CAP SUBJECT)", address: "USCIS Vermont Service Center Attn: I-129 H-1B Regular Cap, 38 River Road Suite 1000Essex Junction, VT 05452" },
  { name: "Nebraska Service Center (Non Premium)", address: "USCIS Nebraska Service Center  850 S Street Lincoln, NE 68508" },
  { name: "Nebraska Service Center (Premium)", address: "USCIS Nebraska Service Center 850 S Street Lincoln, NE 68508" },
  { name: "Nebraska Service Center (CAP SUBJECT)", address: "USCIS Nebraska Service Center 850 ‘S’ Street Room 129CAP Lincoln, NE 6850" },
  { name: "Texas Service Center (Non Premium)", address: "USCIS Texas Service Center Attn: I-129 H1B 6046 N Belt Line Rd. Irving, Texas 75038-0001" },
  { name: "Texas Service Center (Premium)", address: "USCIS Texas Service Center Attn: I-129 H1B Premium Processing 6046 N Belt Line Rd. STE 907 Irving, TX 75038-0022" },
  { name: "Texas Service Center (CAP SUBJECT)", address: "USCIS TSC Attn: H-1B CAP Filings 6046 N Belt Line Rd. STE 107 Irving, TX 75038-0001" },
  { name: "Texas Service Center (PREMIUM CAP SUBJECT)", address: "USCIS TSC Attn: I-129 CAP Premium Processing 6046 N Belt Line Rd. STE 907 Irving, TX 75038-0022" },
  { name: "California Service Center (Non Premium)", address: "USCIS California Service Center Attn: I-129 H-1B Extensions 24000 Avila Road 2nd Floor, Room 2312 Laguna Niguel, CA 92677" },
  { name: "California Service Center (Premium)", address: "Premium Processing Service USCIS California Service Center Attn: I-129 H-1B Extensions 24000 Avila Road 2nd Floor, Room 2312 Laguna Niguel, CA 92677" },
  { name: "California Service Center (REGULAR-CAP SUBJECT)", address: "USCIS California Service Center Attn: I-129 H-1B Regular Cap 24000 Avila Road 1st Floor, Room 1600 Laguna Niguel, CA 92677" },
  { name: "California Service Center (MASTER-CAP SUBJECT)", address: "USCIS California Service CenterAttn: I-129 H-1B Master’s Cap 24000 Avila Road 1st Floor, Room 1600 Laguna Niguel, CA 92677" }
]

export const classificationType = [
  { name: "", displayName: "-Select-" },
  { name: "A", displayName: "New employment (Cap Petition)" },
  { name: "B", displayName: "Extention without Change" },
  { name: "C", displayName: "Concurrent Employment" },
  { name: "D", displayName: "Change Of Employer" },
  { name: "E", displayName: "Amended Petition" },
  { name: "F", displayName: "Employment Extention - Amendment" }

]

export const fileNameFormat = (caseId: any, companyCode: any, lastName: any, docType: any) => {
  return `${caseId}_${companyCode}_${lastName}_${docType}`;
}

export const formatCardNumber = (value: any) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 5) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 9) {
    return `${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4)}`;
  }

  if (phoneNumberLength < 13) {
    return `${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4, 8)} ${phoneNumber.slice(4)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4, 8)} ${phoneNumber.slice(8, 12)}  ${phoneNumber.slice(12, 16)}`;
}

export const formatExpireMonth = (value: any) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 3) return phoneNumber;

}
export const formatExpireYear = (value: any) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 3) return phoneNumber;

}
export const formatCVC = (value: any) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

}

export const formatNumberOnly = (value: any) => {
  if (!value) return value;
  const pincode = value.replace(/[^\d]/g, "");
  return pincode;

}
export const displayI9Type = (i9Type: any) => {
  var displayI9Type = i9Type;
  switch (i9Type) {
    case "1":
      displayI9Type = "New Form I-9";
      break;
    case "2":
      displayI9Type = "Remort Access Form I-9 - Section 1 Only";
      break;
    case "3":
      displayI9Type = "Remort Access Form I-9 - Section 1 & Section 2";
      break;
    case "4":
      displayI9Type = "Historical Form I-9";
      break;

  }
  return displayI9Type;

}
export const DOCU_SIGN_I9_TEMPLATE_ID = 9
export const H1B_EXP_REPORT = 9
export const CASE_STATUS_REPORT = 10
export const MAIL_TRACKING_REPORT = 11
export const yearRange = "1950:"   + (currentYear + 25);
export const passportExpiryDateRange = "1950:"  + (currentYear + 25);
export const convertUTCDateToLocalDate = (date: any) => {
  var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return newDate;
}
export const convertUTCDateToLocalDateWithOutMinus = (date: any) => {
  var newDate = new Date(date.getTime());
  return newDate;
}
export const formatSSNumber = (value: any) => {
  if (!value) return value;
  const ssNumber = value.replace(/[^\d]/g, "");
  const ssNumberLength = ssNumber.length;
  if (ssNumberLength < 4) return ssNumber;
  if (ssNumberLength < 6) {
    return `${ssNumber.slice(0, 3)}-${ssNumber.slice(3)}`;
  }
  return `${ssNumber.slice(0, 3)}-${ssNumber.slice(3, 5)}-${ssNumber.slice(5, 9)}`;
}
export const isNumber = (value: number) => {
  const conv = +value;
  if (conv) {
    return true;
  } else {
    return false;
  }
}

export const dateConverter = (startDate, timeEnd) => {
  const newStartDate = new Date(startDate);
  const newEndDate = new Date(timeEnd);
  let result = moment(newStartDate).diff(newEndDate, 'days')
  return result
}

export const dateDifference = (startDate, timeEnd) => {
  let result = moment(startDate).diff(timeEnd, 'days')
  //  let result=moment(startDate).diff(timeEnd,'days')
  return result
}

export const addDays = (startDate, days) => {
  try {
    const newDate = new Date(startDate.getTime());
    newDate.setDate(startDate.getDate() + days);
    return newDate;
  } catch (e) {
    return startDate;
  }
};
export const extension = /(?:\.([^.]+))?$/;
export const imageextension = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
export const docsextension = ["doc", "docx", "txt"];
export const testDD = [{ "R": "Patient Room", "BR": "bath Room", "D": "Dinning Room", "G": "Group Room", "GA": "Garden", "H": "Hallway", "M": "Milieu", "O": "Other(Specify)" }];
export const countryCode = [{ "code": "+1" }, { "code": "+91" }];
export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement("script");
  script.src = urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

export function displayTypesOfLca(typesOfLca) {
  var displayTypesOfLca = typesOfLca;
  switch (typesOfLca) {
    case "1":
      displayTypesOfLca = "New Petition – Cap/Change of Status";
      break;
    case "2":
      displayTypesOfLca = "Extension (from current date of expiry)";
      break;
    case "3":
      displayTypesOfLca = "Amendment (only till current petition expiry date)";
      break;
    case "4":
      displayTypesOfLca = "Amend + Extension (from now and beyond current petition expiry date)";
      break;
    case "5":
      displayTypesOfLca = "Transfer/ Change of Employer";
      break;
  }
  return displayTypesOfLca;
}
export function tokenValid(created_at, expires_in) {
  const currentDate = moment().utc();
  if (created_at !== null && created_at !== "") {
    created_at = Date.parse(created_at);
  }
  var totalParse = parseInt(created_at) + parseInt(expires_in) * 300;
  const expiryDate = moment(totalParse).utc();

  return currentDate < expiryDate;
}
export const formatMonthYearAwarded = (value) => {
  // Ensure value is a string
  if (typeof value !== 'string') return value;

  // Remove any non-numeric characters
  const numericValue = value.replace(/\D/g, '');

  // Check if the length of numericValue is at least 6
  if (numericValue.length < 6) return value; // Return original value if not enough digits

  // Extract month and year from the numeric value
  const month = numericValue.substring(0, 2);
  const year = numericValue.substring(2, 6);

  // Validate month
  const monthNumber = parseInt(month, 10);
  if (monthNumber < 1 || monthNumber > 12) return value; // Invalid month, return original value

  // Return formatted date
  return `${month}/${year}`;
};
export const dateDifference1 = (startDate, timeEnd) => {
  const diffTime = new Date(startDate).getTime() - new Date(timeEnd).getTime();
  return Math.ceil(diffTime / (1000 * 3600 * 24));
}

export function displayDateMMDDYYYY(dateValue) {
  var displayDate = dateValue;
  
  if (moment(dateValue, 'MM/DD/YYYY', true).isValid()) {
    displayDate=  dateValue ;
  } else if (moment(dateValue, 'YYYY-MM-DDTHH:mm:ss.000Z', true).isValid()) {
    displayDate=  dateValue !== null ? moment(dateValue, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/YYYY") : "";
 
  } else if (moment(dateValue, 'ddd MMM D YYYY HH:MM:SS [GMT]ZZ', true).isValid()) {
    displayDate=  dateValue !== null ? moment(dateValue, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/YYYY") : "";
 
  } else if (moment(dateValue, 'YYYY-MM-DDTHH:mm:ss', true).isValid()) {
    displayDate=  dateValue !== null ? moment(dateValue, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/YYYY") : "";
  
  }

  return displayDate;
}

export const routeTitleMap = {
  "/visaCareCreateEmployer": "Create Customer/Employer Account",
  "/visaCareAttorneyDashboard": "Attorney Dashboard",
  "/vCareDashboard": "Dashboard",
  "/visaCareManageCase": "Manage Cases",
  "/visaCareManageOrderCases": "Manage Order Cases",
  "/visaCareAddCorporateSetup": "Employer Profile",
  "/vCareManageUser": "Manage User",
  "/visaCareEmployerCaseDetails": "Employer Case Details",
  "/visaCareReportPageView": "Reports",
  "/visaCareSubscriptionFrequencyEmployerView": "Subscription Frequency Employer",
  "/staticui/setpassword": "Change/Update Password",
  "/visaCareH1BCaseDetails": "I-129 - H1B Petition Case Details",
  "/visaCareH4CaseDetails": "I-539 - H4 Application Case Details",
  "/visaCareI765CaseDetails": "I-765 - EAD Application",
  "/visaCareCreateUser": "Create User",
  "/visaCareStripePaymentMethod": "Stripe Payment Details",
  "/visaCarePublicAccessFiles": "H1B Public Access File Only",
  "/visaCareLcaRequestDetails": "LCA Request Details",
  "/visaCareNewH1BDetails": "I-129 - H1B Petition Case Details",
  "/visaCareH4EmployeeNewCaseDetails": "I-539 - H4 Application Case Details",
  "/visaCareI765NewCaseDetails": "I-765 - EAD Application Case Details",
  "/visaCareI130BeneficiaryQuestionnaier": "I-130 Beneficiary Questionnaire",
  "/visaCareI130PetitionerQuestionnaier": "I-130 Application  Petitioner Questionnaire",
  "/visaCareI131PetitionerQuestionnaier": "I-131 Petitioner Questionnaire",
  "/visaCareI864Questionnaier": "I-864 Questionnaire",
  "/visaCareI485Questionnaier": "I-485 Questionnaire",
  "/visaCareI130CaseDetails": "I-130 Application Case Details",
  "/visaCareI131CaseDetails": "I-131 Advanced Parole - Depends",
  "/visaCareI864CaseDetails": "I-864 Petition",
  "/visaCareI130ACaseDetails": "I-130A Application",
  "/visaCareI485CaseDetails": "I-485 Application",
  "/visaCarePermCaseDetails": "PERM Application",
  "/visaCareCreatei9": "Create I-9",
  "/visaCarei9SearchDetails": "I-9 Details",
  "/visaCareI9Dashboard": "I-9 Dashboard",
  "/visaCareAddI9Section1": "I-9 Section 1",
  "/visaCareH1BQuestionnaier": "I-129 - H1B Petition Questionnaire",
  "/visaCareEmploymentInfo" : "Employee Information",
  "/visaCareDocumentH4CaseDetails": "Document I-539 - H4 Application Case Details",
  "/visaCareDocumentCaseDetails": "Document I-129 - H1B Petition Case Details",
  "/visaCareDocumentEADCaseDetails": "Document I-765 - EAD Application Case Details",
  "/visaCareDocumentI140CaseDetails": "Document I140 Case Details",
  "/visaCareDocumentLCAPAFCaseDetails": "Document LCA/PAF Case Details",
  "/visaCareDocumentI485CaseDetails": "Document I485 Case Details",
  "/visaCareDocumentPermCaseDetails": "Document PERM Application Case Details",
  "/visaCareDocumentI94CaseDetails": "Document I94 Case Details",
  "/visaCareAttorneyCaseDetails" : "Immigration Case Details",
  "/vCareAttorneyUser" : "Attorney User",
  "/visaCareFLCCaseDetails" : "H1B LCA Only",
  "/visaCareCasesRFEStatus" : "Company Case Details",
  "/visacareMyCases" : "My Case Details",
  "/visaCarePAFCaseDetails" : "Public Access File Only Case Details",
  "/visaCareI140Questionnaier" : "I-140 Application Questionnaire",
  "/visaCareI140CaseDetails" : "I-140 Application Case Details",
  "/visaCareAddNewAttorney" : "Attorney Details"
};

export function getPageTitle(pathname) {
  const entry = Object.entries(routeTitleMap).find(([key]) => pathname.includes(key));
  return entry ? entry[1] : "";
};

export const ImportAddressQuest = "Can I help to import the address..?";
export const ImportAddressAnswer1 = "Yes, you need to choose one option to import the appropriate address.";
export const ImportAddressAnswer2 = "No, you don't need to import an address, so I'm closing the chat box.";

export const ImportEmpQuest = "Can I help to import the employment details..?";
export const ImportEmpAnswer1 = "Yes, you need to choose one option to import the appropriate employment detail.";
export const ImportEmpAnswer2 = "No, you don't need to import an employment detail, so I'm closing the chat box.";

export    const dateCaseHistory = (rowData: any, column: any) => {
        if (rowData.creationDate !== null && rowData.creationDate !== null) {
            return moment(rowData.creationDate, "YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY");
        } else {
            return "--";
        }


    }
export    const updateCaseBasedOnLastWorkflowId = (decRyptCaseId: any, initialWFId: any, LastWFId: any) => {
 
    try{
   
       
if(initialWFId<LastWFId){
    var objStatusUpdate =
    {
      "caseId": decRyptCaseId,
      "lastWorkFlowId": LastWFId
    }

    HttpCase.axios().post(
      "/caseflow/updateCaseBasedOnLWFId", objStatusUpdate,
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*",
        },
      },
    )
      .then((response) => {
 
      })
      .catch((e) => { })
      .finally(() => { });
}}catch(exception){
console.log(exception);
}
  }

export const ImportEmployerAddressQuest = "Can I help to import the employer's address..?";
export const ImportEmployerAddressAnswer1 = "Yes, I'm importing the employer's address into this work location.";
